module.exports = __webpack_public_path__ + "static/img/twjd-sdo18.365c4c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdo18.png
// module id = 860
// module chunks = 0